import styled from 'styled-components';

export const IconContainerDefaultBox = styled.img`
    padding: 8px;
    background-color: ${props => props.theme.colors.backgroundDark};
    border: 1px solid black;
    border-radius: 20%;
    height: 50px;
    width: 52px;
`;